import type { ThemeProps } from './theme';
import { hostnameFromUrl, isLocalDevHost } from './hostGuards';

export function triggerRedirectIfRequired(theme: Pick<ThemeProps, 'redirectToUrl' | 'website'>): void {
  const currentHost = window.location.hostname;

  if (isLocalDevHost(currentHost)) {
    return;
  }

  if (theme.redirectToUrl) {
    const redirectHost = hostnameFromUrl(theme.redirectToUrl);

    if (!redirectHost || redirectHost === currentHost) {
      return;
    }

    window.location.href = theme.redirectToUrl;
    return;
  }

  if (!theme.website) {
    return;
  }

  const websiteHost = hostnameFromUrl(theme.website);

  if (!websiteHost || websiteHost === currentHost || `www.${websiteHost}` === currentHost) {
    return;
  }

  window.location.href = theme.website;
}

